(function () {
    'use strict';

    angular
        .module('app.dailySetup')
        .controller('ReactDailySetupController', ReactDailySetupController);

    ReactDailySetupController.$inject = ['$scope', '$filter', '$state', 'common', 'dataservice', 'completionsDataService',
        'userService', 'backendHubProxy', '$interval', 'notesDataService', '$window', 'linkedTask.dialog' ];
    /* @ngInject */
    function ReactDailySetupController($scope, $filter, $state, common, dataservice, completionsDataService, userService, 
        backendHubProxy, $interval, notesDataService, $window, linkedTaskDiag ) {
        var vm = this;
        
        vm.common = common;

        vm.connectionStatus = "";
        vm.showDailySetup = userService.hasDataApi() == "1";
        vm.minutesSinceLastChangeFlag = 1440;
        vm.isLoading = true;
        vm.title = "Daily Setup"
        vm.items = [];
        vm.displayedItems = [];
        vm.soScheduleItemCount = 0;
        vm.serviceDisplayedItems = [];
        vm.refresh = refresh;
        vm.completionsDataService = completionsDataService;
        vm.notesDataService = notesDataService;
        vm.userService = common.userService;
        vm.dataService = dataservice;
        vm.editTask = editTask;
        vm.updateBookingWithTaskId = updateBookingWithTaskId;
        vm.relatedBookings = [];
        vm.bookData = [];
        vm.lastRefreshed = "loading";
        vm.showRoomCode = $window.localStorage.getItem("OpsShowRoomCode") == "true" ? true : false;
        vm.openNewTaskModal = openNewTaskModal;
        vm.onDate = common.getMainState("mainDate");

        vm.expandAllServices = false;
        vm.expandAllServicesToggle = expandAllServicesToggle;
        vm.showHistoricalItems = true;
        vm.limitToCheckedInBookings = false;
        
        vm.allBookings = [];
        vm.tasks = [];
        vm.origTasks = [];
        vm.origAllBookings = [];
        vm.limitCompletionsByDepartment = false;
        
        vm.setAvailableAt = setAvailableAt;
        
        vm.allCompletionTypes = [];
        vm.clearSearch = clearSearch;
        vm.showReservedTime = showReservedTime;
        vm.toggleServices = toggleServices;
        vm.showCheckinFilter = showCheckinFilter;
        
        vm.settings = [];
        
        vm.filtersSet = false;

        vm.getHistoryForBooking = getHistoryForBooking;
        vm.getDailySetupForLinkedBooking = getDailySetupForLinkedBooking;
        vm.noEventsMessage = "No Events";
        vm.apiVersion = 0;
        vm.apiTypeId = common.userService.apiTypeId();
        vm.updateItemForBookingAction = updateItemForBookingAction;
        vm.updateSod = updateSod;


        vm.showNoShowAction = false;
        vm.showEstimatedCountAction = false;
        vm.showAddToCalendarAction = false;

        vm.filters = {
            GmtFromDate: '1/1/2015',
            GmtToDate: new Date().toUTCString(),
            Buildings: [-1],
            Statuses: [-1],
            Categories: [-1],
            Views: [],
            Udfs: [],
            LimitToBookingsWithSelectedCategories: false,
            LocalDateOnlyIsoString: moment(vm.onDate).format("YYYY-MM-DD"),
            ShowEventsWithinThisManyDays : null
        };

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });
      

        vm.viewStatus = "Disable Mobile View";
        vm.toggleFullView = toggleFullView;

        vm.sort = sort;
        vm.currentSortColumn = "";
        vm.isSortDesc = false;
        vm.currentSortParser = null;

        var _forcedToast = null;

        function openNewTaskModal(item) {
            linkedTaskDiag.display(item, vm.settings).then(function (i) {
               
                //updateBookingWithTaskId(item, i.data.TaskId);
            }, function () { });;
}
        

        function sort(collectionToSort, propertyName, parser, sortProperty, initial) {
            
            propertyName = sortProperty || propertyName;
            if (!initial) {
            
            if (vm.currentSortColumn === propertyName) {
                vm.isSortDesc = !vm.isSortDesc;
            }
            else {
                vm.isSortDesc = false;
                }
            }

            vm.currentSortColumn = propertyName;

            try {
                $window.localStorage.setItem("OpsDailySetupSort", propertyName);
                $window.localStorage.setItem("OpsDailySetupSortDesc", vm.isSortDesc); 
            }
            catch (e) {
                console.log(e);
            }
            
            var props = {
                prop: propertyName,
                desc: vm.isSortDesc
            };

            vm.currentSortParser = parser;
            if (parser) {
                props.parser = parser;
            }

            //_sortBy(vm.displayedItems, props)
            _sortBy(collectionToSort, props);
        }

       
       
        activate();

        function activate() {
            if ($window.localStorage.getItem("DisableOpsMobileView") === "1") {
                vm.viewStatus = "Enable Mobile View";
                $('link[title=responsiveCss]')[0].disabled = true;
                $('body').addClass("forceFull");
            }
            try {
                vm.currentSortColumn = $window.localStorage.getItem("OpsDailySetupSort") || "";
                vm.isSortDesc = $window.localStorage.getItem("OpsDailySetupSortDesc") === "true" ? true : false;
            }
            catch (e) {
                console.log(e);
            }
            
            

            common.notifier.subscribe(common.config.events.signalRStatusChange, $scope, function (eventName, data) {
                vm.connectionStatus = data;
            });
            common.notifier.subscribe(common.config.events.filterCleared, $scope, function (eventName, data) {
                vm.showHistoricalItems = true;
            });

            _initFilters();
            backendHubProxy.displayedItems = vm.displayedItems;
            backendHubProxy.startListening();

            common.notifier.subscribe(common.config.events.userConfigOptionsChange, $scope, filtersChanged);
            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);
            completionsDataService.clearCache();
            var promises = [loadData()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(common.config.events.refreshCounts);
                vm.showNoShowAction = ((vm.apiVersion >= 5 && vm.apiTypeId === common.config.apiTypes.sevenPoint) || vm.apiTypeId === common.config.apiTypes.ems) && moment(vm.onDate).isSame(moment(), 'day');;
                vm.showEstimatedCountAction = ((vm.apiVersion >= 5 && vm.apiTypeId === common.config.apiTypes.sevenPoint) || vm.apiTypeId === common.config.apiTypes.ems) && (moment(vm.onDate).isSame(moment(), 'day') || moment(vm.onDate).isBefore(moment(), 'day'));
                
                vm.showAddToCalendarAction = _getSettingValue("ShowAddToCalendar") == 1;

                vm.isLoading = false;
            }, function (error) { });
        }

        function getHistoryForBooking(item) {
            if (vm.apiTypeId === common.config.apiTypes.sevenPoint || vm.apiTypeId === common.config.apiTypes.ems) {

                return dataservice.getItems('api/DailySetup/HistoryForBooking/' + item.BookingId)
                    .then(function (response) {
                        item.history = response.data;
                        _updateItemInCollection(vm.allBookings, item, "BookingId")
                    }, function (error) { });
            }
           
        }


        function showCheckinFilter() {
            var apiTypeId = userService.apiTypeId();
            if (apiTypeId === "4CF523BF-F6DD-441C-810F-C87347963B5D" || apiTypeId === "BCA944F7-7795-45CD-A21B-CB5F16DC4175") {
                return _getSettingValue("IncludeCheckinFilter") == 1;
            };
            return false;
         }
        
        

        function updateItemForBookingAction(newItem) {
            
                for(var i = 0; i < vm.filters.Statuses.length; i++) {
                    if(vm.filters.Statuses[i] == newItem.Status.ID) {
                        _updateItemInCollection(vm.allBookings, newItem, "BookingId");
                        return newItem;
                    }
                }
                removeItemFromCollection(vm.allBookings, newItem, "BookingId");
        }


        function _updateItemInCollection(collection, item, propertyName) {
           
            var tempCollection = collection.concat();
            for (var i = 0; i < tempCollection.length; i++) {
                if (tempCollection[i][propertyName] === item[propertyName]) {
                    tempCollection[i] = item;
                    break;
                }
            }
       
            collection = tempCollection;
        }

        function removeItemFromCollection(collection, item, propertyName) {
            var tempCollection = collection.concat();
            for (var i = 0; i < tempCollection.length; i++) {
                if (tempCollection[i][propertyName] === item[propertyName]) {
                    tempCollection.splice(i, 1);
                    break;
                }
            }
            collection = tempCollection;
        }

        function toggleServices(item) {
            if (item) {
                item.servicesShowing = !item.servicesShowing;
            }
            _updateItemInCollection(vm.allBookings, item, "BookingId");
        }

        function updateBookingWithTaskId(item, linkedItemId) {
            item.LinkedTaskId = linkedItemId;
            _updateItemInCollection(vm.allBookings, item, "BookingId");
        }
       
        function toggleFullView() {
            if (vm.viewStatus === "Disable Mobile View") {
                $window.localStorage.setItem("DisableOpsMobileView", "1");
                vm.viewStatus = "Enable Mobile View";

                $('link[title=responsiveCss]')[0].disabled = true;
                $('body').addClass("forceFull");
            }
            else {
                vm.viewStatus = "Disable Mobile View";
                $window.localStorage.setItem("DisableOpsMobileView", "0");
                $('link[title=responsiveCss]')[0].disabled = false;
                $('body').removeClass("forceFull");
                
            }
        }

        function editTask(item) {
            $state.go("tasks.details", { id: item.TaskId, fromDisplay: true, fromDailySetup: true });
        }

        var _showReservedTime;
        function _setReservedDisplay() {
            var filterData = userService.filterData();
            if (filterData) {
                _showReservedTime = filterData.showReservedTimes ? 1 : 0;
            }
            else {
                _showReservedTime = 1;
            }
        }

       
        function showReservedTime() {
            if (_showReservedTime == undefined) {
                _setReservedDisplay();
            }
            return _showReservedTime == 1;
        }
        

        function expandAllServicesToggle() {
            vm.expandAllServices = !vm.expandAllServices;
        }

        function clearSearch() {
            document.getElementById("searchBox").value = "";
        }

        function cancelAvailableAt(item) {
            vm.availableAtId = -1;
            vm.availableAtTime = null;
        }

        function setAvailableAt(item, selectedTime) {
            var dto = {};
            dto.BookingId = item.BookingId;

            dto.AvailableAt = selectedTime;

            dataservice.saveItem('api/DailySetup/SetAvailableAt', dto).then(function (response) {
                
            }, function (error) { });
        }

        //we need this for signalr stuff
        $scope.$watchCollection('vm.displayedItems', function (newCollection, oldCollection, scope) {
            _setBookingCollections();
        })

        function updateSod(item, sod) {
            var dto = {

            };
            dataservice.saveItem('api/DailySetup/UpdateSod', dto).then(function (response) {

            }, function (error) { });
        }

        function _setBookingCollections() {
            vm.allBookings = [];
            vm.tasks = [];
            if (vm.displayedItems && vm.displayedItems.length > 0) {
                
                vm.displayedItems.map(function (item) {
                    if (item.TaskId == 0) {
                        if (!item.IsLinkedToTask) {
                            vm.allBookings.push(item);
                        }
                    }
                    else {
                        vm.tasks.push(item);
                    }
                });
            }
            
        }
        
        function _initFilters() {

            var gmtToDate = new Date();
            gmtToDate.setHours(0, 0, 0, 0);
            vm.filters.GmtToDate = moment(gmtToDate).add(1, 'd').toDate();

            var filterData = userService.filterData();
            
            if (filterData) {
                if (filterData.categories) {
                    var roomChargeIndex = filterData.categories.indexOf("2147483647");
                    if (roomChargeIndex > -1) {
                        filterData.categories.splice(roomChargeIndex, 1);
                    }
                }
                vm.filters.Buildings = filterData.buildings;
                vm.filters.Statuses = filterData.statuses;
                vm.filters.Categories = filterData.categories;
                vm.filters.RoomTypes = filterData.roomTypes || [];
                vm.filters.EventTypes = filterData.eventTypes || [];
                vm.filters.Views = filterData.views || [];
                vm.filters.Udfs = filterData.udfs || [];
                vm.filters.LimitToBookingsWithSelectedCategories = filterData.includeBookingWithCategoriesOnly;
                vm.minutesSinceLastChangeFlag = filterData.highlightChangesWithin;
                vm.filters.showReservedTimes = filterData.showReservedTimes;
                vm.filters.ShowEventsWithinThisManyDays = filterData.ShowEventsWithinThisManyDays;
            }            
            
        }
       
        function _setfilterDates() {
            var gmtFromDate = new Date(vm.onDate);
            
            gmtFromDate.setHours(0, 0, 0, 0);
          
            vm.filters.GmtFromDate = gmtFromDate;
            vm.filters.LocalDateOnlyIsoString = moment(vm.onDate).format("YYYY-MM-DD");
            vm.filters.GmtToDate = moment(gmtFromDate).add(1, 'd').toDate();
        }

        function filtersChanged(eventName, data) {
            
            _initFilters();
            _setReservedDisplay();
            getItems(true);
        }

        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            vm.showNoShowAction = ((vm.apiVersion >= 5 && vm.apiTypeId === common.config.apiTypes.sevenPoint) || vm.apiTypeId === common.config.apiTypes.ems) && moment(vm.onDate).isSame(moment(), 'day');;
            vm.showEstimatedCountAction = ((vm.apiVersion >= 5 && vm.apiTypeId === common.config.apiTypes.sevenPoint) || vm.apiTypeId === common.config.apiTypes.ems) && (moment(vm.onDate).isSame(moment(), 'day') || moment(vm.onDate).isBefore(moment(), 'day'));
            getItems(true);
        }

        

        function loadData() {
            if (vm.apiTypeId !== common.config.apiTypes.centersXml && vm.showDailySetup) {
                if (!vm.filters.Buildings || !vm.filters.Statuses) {
                    common.logger.error("Filters aren't set");
                    vm.filtersSet = false;
                    return;
                }
                else {
                    vm.filtersSet = true;
                }
            }
            else {
                vm.filtersSet = true;
            }

            _setfilterDates();

            

            return dataservice.query('api/DailySetup/InitData', vm.filters).then(function (response) {
                var loadData = response.data;
                vm.settings = loadData.Settings;
                vm.allCompletionTypes = loadData.CompletionTypes;
                vm.apiVersion = loadData.ApiVersion;
                _processItems(loadData.Data);

                vm.expandAllServices = _getSettingValue("ExpandServicesOnLoad") == 1;

                vm.bookData = loadData.BookData;
                return vm.items;
            }, function (error) { });

        }

        function _getSettingValue(settingKey) {
            if (!vm.settings) {
                return "";
            }
            for (var i = 0; i < vm.settings.length; i++) {
                if (vm.settings[i].SettingKey == settingKey) {
                    return vm.settings[i].SettingValue;
                }
            }
        }

        function getItems(refreshCache) {
            if (!refreshCache) {
                refreshCache = false;
            }


            _stop();
            _setfilterDates();

            if (vm.filters.ShowEventsWithinThisManyDays) {
                var gmtFromDate = moment(vm.filters.GmtFromDate);
                var lastDate = new Date();
                lastDate.setHours(0, 0, 0, 0);
                if (moment(lastDate).add(vm.filters.ShowEventsWithinThisManyDays, 'days').isBefore(gmtFromDate)) {
                    vm.noEventsMessage = "Your filter does not allow you to see events on this date";
                }
                else {
                    vm.noEventsMessage = "No Events";
                }
            }
            vm.filters.RefreshCache = refreshCache;
            vm.lastRefreshed = "loading"
          
            if (vm.filters && vm.filters.Categories) {
                var roomChargeIndex = vm.filters.Categories.indexOf("2147483647");
                if (roomChargeIndex > -1) {
                    vm.filters.Categories.splice(roomChargeIndex, 1);
                }
            }
            
            return dataservice.query('api/DailySetup', vm.filters).then(function (response) {
                var data = response.data;
                
                if (data.BookData) {
                    vm.bookData = data.BookData;
                    _processItems(data.displayData);
                }
                else {
                    _processItems(data);
                }
                return vm.items;
            }, function (error) { });
        }

        function getDailySetupForLinkedBooking(item) {
           
            item.showingRelatedBooking = !item.showingRelatedBooking;
            if (item.RelatedBookingItem) {
             
                _updateItemInCollection(vm.tasks, item, "TaskId");
                return;
            }
            _stop();
            _setfilterDates();

            return dataservice.query('api/DailySetup/ForBooking/' + item.LinkedBookingId, vm.filters).then(function (response) {
                var data = response.data;
                if (data.length === 1) {
                    _updateTimes(data);
                    var b = data[0];
                    item.RelatedBookingItem = b;
                    //vm.allBookings.push(b);
                    vm.items.push(b);
                    _updateItemInCollection(vm.tasks, item, "TaskId");
                }
                else {
                    common.logger.error("We couldn't find the booking. Make sure that your filters are set to include it.");
                }
                _start();
            }, function (error) { });
        }

        function _updateTimes(items) {
            var numberOfItemsRequiringAttention = 0;
            for (var i = 0; i < items.length; i++) {
                var onItem = items[i];
                onItem.BuildingLocalReseveredStartDisplay = moment(onItem.BuildingLocalReseveredStart).format("LT");
                onItem.BuildingLocalReseveredEndDisplay = moment(onItem.BuildingLocalReseveredEnd).format("LT");
                onItem.BuildingLocalEventStartDisplay = moment(onItem.BuildingLocalEventStart).format("LT");
                onItem.BuildingLocalEventEndDisplay = moment(onItem.BuildingLocalEventEnd).format("LT");
                if (onItem.RequiresAcknowledgement) {
                    numberOfItemsRequiringAttention++;
                }
            }
            return numberOfItemsRequiringAttention;
        }
        
        function _processItems(items) {
            
            if (!items) {
                items = [];
            }
            else if (items.Message) {
                common.logger.error("An error occurred trying to load your items, you should contact 7 Point Solutions if the problem persists");
                items = [];
            }
            var numberOfItemsRequiringAttention = _updateTimes(items);;

            if (numberOfItemsRequiringAttention > 0) {
                _forcedToast = common.logger.forceAcknowledge("There are " + numberOfItemsRequiringAttention + " items that need your attention", "Urgent Action Required");
            }
            else {
                common.logger.clearToast(_forcedToast);
                _forcedToast = null;
            }

            vm.items = items;
            
            vm.displayedItems = [].concat(vm.items);
            
            vm.origTasks = [];
            vm.origAllBookings = [];
            
            items.map(function (item) {
                if (item.TaskId == 0) {
                    vm.origAllBookings.push(item);
                }
                else {
                    vm.origTasks.push(item);
                }
            })
            if (vm.currentSortColumn !== "") {
                sort(items, vm.currentSortColumn, vm.currentSortParser, null, true);
            }
            
            
            _setBookingCollections();
            backendHubProxy.items = vm.items;
            backendHubProxy.displayedItems = vm.displayedItems;
            _refreshDataIn = defaultRefreshTime();
            vm.lastRefreshed = moment().format("hh:mm A");
            _start();
        }

        function refresh() {
            getItems(true);
        }

        var _autoRefreshDisabled = false;
        
        function defaultRefreshTime() {
            var refreshFromSetting = _getSettingValue("DailySetupAutoRefreshInterval");
            if (refreshFromSetting == 0) {
                _autoRefreshDisabled = true;
            }
            if (refreshFromSetting) {
                var asint = parseInt(refreshFromSetting);
                if (isNaN(asint)) {
                    return 600000;
                }

                return asint * 60000;
            }
            return 600000;
        }


        var _timerPromise, _tickPromise, _refreshDataIn = 0;

        function _tick() {
            
            if (_refreshDataIn >= 0) {
                _refreshDataIn = _refreshDataIn - 1000;
            }
            else {
                _refreshDataIn = defaultRefreshTime();
            }
        }

        function _stop() {
            common.$timeout.cancel(_timerPromise);
            $interval.cancel(_tickPromise);
        }

        function _start() {
            _stop();
            _tickPromise = $interval(_tick, 1000);
            if (_autoRefreshDisabled === false) {
                _timerPromise = common.$timeout(getItems, _refreshDataIn);
            }
        }



        $scope.$on('$destroy', function () {
            _stop();
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

        var _sortBy = (function () {

            var _defaults = {
                parser: function parser(x) {
                    return x;
                },
                desc: false
            };

            var isObject = function isObject(o) {
                return o !== null && (typeof o === "undefined" ? "undefined" : _typeof(o)) === "object";
            };
            var isDefined = function isDefined(v) {
                return typeof v !== "undefined";
            };

            //gets the item to be sorted
            function getItem(x) {
                var sortObj = x;
                var sortProp = this.prop;
                var parts = this.prop.split('.');
                if (parts.length > 1) {
                    sortObj = x[parts[0]];
                    sortProp = parts[1];
                }
                var isProp = isObject(sortObj) && isDefined(sortObj[sortProp]);
                
                return this.parser(isProp ? sortObj[sortProp] : sortObj);
            }

            return function (array, options) {
                if (!(array instanceof Array) || !array.length) return [];
                var opt = Object.assign({}, _defaults, options);
                opt.desc = opt.desc ? -1 : 1;
                return array.sort(function (a, b) {

                    a = getItem.call(opt, a);
                    b = getItem.call(opt, b);
                    if (a === null) {
                        return -1;
                    } else if (b === null) {
                        return 1;
                    }
                    a = a.toLowerCase();
                    b = b.toLowerCase();
                    return opt.desc * (a < b ? -1 : +(a > b));
                });
            };
        })();

    }
})();
